import React from "react";
import { Box, VStack, HStack, Text, Divider } from "@chakra-ui/react";
import { useAuth } from "../../context/AuthContext";
import { formatTimeStamp } from "../../logics/timeLogic";
import {
  FormatCallDuration,
  getCallDirectionIcons,
  getCallTypeIcons,
} from "../../logics/callLogic";
import { MdInfoOutline } from "react-icons/md";

const UserCallHistory = ({ callList }) => {
  const { currentUser } = useAuth();

  const handleOpenCallInfoPopup = (pCallData) => {
    const status = pCallData?.currentStatus?.status;
    const name = pCallData?.currentStatus?.createdBy?.name;
    alert(`Call ${status}, by ${name}`);
  };

  return (
    <Box
      bg="white"
      flex="1"
      boxShadow="sm"
      overflowY="auto"
      maxH="60vh"
      minH="60vh"
    >
      <VStack align="start" spacing={0} w="100%" p={0}>
        {callList.map((callData, index) => (
          <HStack w="full" p={2} spacing={2} key={callData._id}>
            <Box flex="1">
              <HStack justifyContent="space-between">
                <Text fontSize="xs" color="gray.600" as="b">
                  {formatTimeStamp(callData.createdAt)}
                </Text>
              </HStack>

              <HStack justifyContent="space-between" w="full">
                <HStack spacing={2}>
                  {getCallTypeIcons(callData.type)}
                  {getCallDirectionIcons(callData, currentUser)}
                  {FormatCallDuration(callData, currentUser)}
                </HStack>
                <MdInfoOutline
                  cursor="pointer"
                  color="teal"
                  size={25}
                  onClick={() => handleOpenCallInfoPopup(callData)}
                />
              </HStack>
              {index < callList.length - 1 && <Divider />}
            </Box>
          </HStack>
        ))}
      </VStack>
    </Box>
  );
};

export default UserCallHistory;
